import { render } from "./MileStone.vue?vue&type=template&id=65f939dc&scoped=true"
import script from "./MileStone.vue?vue&type=script&lang=js"
export * from "./MileStone.vue?vue&type=script&lang=js"

import "./MileStone.vue?vue&type=style&index=0&id=65f939dc&lang=css"
import "./MileStone.vue?vue&type=style&index=1&id=65f939dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f939dc"]])

export default __exports__